import { render, staticRenderFns } from "./mailSending.vue?vue&type=template&id=9a02f5a4&scoped=true&"
import script from "./mailSending.vue?vue&type=script&lang=js&"
export * from "./mailSending.vue?vue&type=script&lang=js&"
import style0 from "./mailSending.vue?vue&type=style&index=0&id=9a02f5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a02f5a4",
  null
  
)

export default component.exports